module.exports = __webpack_public_path__ + "src/assets/img/m41.6f6d3641.svg";